import config from 'config/default'

const { baseUrl } = config

/**
 * 获取一期讲座信息
 * @param name
 */
export const getGeneralList = async opt => {
    const url = `${baseUrl}/data/generalList/${opt.theme}.json`
    return await fetch(url)
        .then(resp => resp.json())
        .catch(() => null)
}